export default __webpack_public_path__ + "static/media/tutorial1-6.f5770a8d.png";